import type { Filter } from "@interfaces/filters/catalog";

/**
 * Single rule for which catalog filter is "the age filter".
 *
 * The bootstrap catalog carries no explicit age role, so age is the RANGE
 * filter named "Age" (by `name` or `displayLabel`, case-insensitive). When no
 * RANGE filter is named that way it falls back to the first RANGE filter,
 * which is what every caller did before more than one range filter could
 * exist. Switch this to a role/type field once the bootstrap provides one.
 *
 * Kept dependency-free (type import only) so selectors and draft helpers can
 * use it without import cycles.
 */
export function findAgeFilter<
  T extends Pick<Filter, "kind" | "name" | "displayLabel">,
>(filters: readonly (T | null | undefined)[]): T | undefined {
  let firstRange: T | undefined;
  for (const filter of filters) {
    if (!filter || filter.kind !== "RANGE") continue;
    if (
      filter.name?.trim().toLowerCase() === "age" ||
      filter.displayLabel?.trim().toLowerCase() === "age"
    ) {
      return filter;
    }
    firstRange ??= filter;
  }
  return firstRange;
}
